<div class="horizinns-container profile-container">
    <mat-card class="profile-card horizinns-card mw-80">
        <mat-card-content>
            <app-like-list (totalLikesChange)="onTotalLikesChange($event)"></app-like-list>
        </mat-card-content>
    </mat-card>
</div>